import React from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  useTheme,
  makeStyles,
  Hidden,
  ClickAwayListener
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styles } from './header.styles';
import { HeaderMenu } from './headerMenu';
import { HeaderMenuMobile } from './headerMenuMobile';
import { Loading } from '../../../shared';

export interface HeaderProps {
  onToggleAutoCollapse: () => void;
  clickAway: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onToggleAutoCollapse, clickAway }) => {
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  return (
    <AppBar position="fixed" className={classes.appBar} elevation={0}>
      <Toolbar variant="dense">
        <ClickAwayListener onClickAway={clickAway}>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={onToggleAutoCollapse}
          >
            <FontAwesomeIcon icon="bars" />
          </IconButton>
        </ClickAwayListener>
        <div className={classes.logo}></div>
        <div className={classes.grow} />
        <Hidden smDown>
          <HeaderMenu></HeaderMenu>
        </Hidden>
        <Hidden mdUp>
          <HeaderMenuMobile></HeaderMenuMobile>
        </Hidden>
      </Toolbar>
      <Loading></Loading>
    </AppBar>
  );
};

export default React.memo(Header);
